import { User } from '@elio/emanager-front/auth/model';
import { ProfessionalView } from '@elio/emanager-front/professional/offer/model';
import { createAction, props } from '@ngrx/store';

const upsertProfessionalPush = createAction(
  '[Professional push Effect] upsert professional after PUSH',
  props<{ professionalView: ProfessionalView }>()
);

const leaveOfferPush = createAction(
  '[Professional push Effect] professional leave offer PUSH',
  props<{ professionalId: number }>()
);

const leaveUniqueOffer = createAction('[Professional push Effect] professional leaves his unique offer');

const leaveOneOffer = createAction(
  '[Professional push Effect] professional leaves one of his offers',
  props<{ user: User; offerId: number }>()
);

export const ProfessionalPushActions = {
  upsertProfessionalPush,
  leaveOfferPush,
  leaveUniqueOffer,
  leaveOneOffer,
};
